// extracted by mini-css-extract-plugin
export default {"warpper":"App_warpper__3j1r1","title":"App_title__Uj2m0"};